import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { FormLabel } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";

class LegalCheckbox extends React.PureComponent {
  constructor(props) {
    super(props);
    // This binding is necessary to make `this` work in the callback
    this.handleAggree = this.handleAggree.bind(this);
  }
  UNSAFE_componentWillMount() {
    const {
      value,
      context,
      children,
      name,
      setFieldValue,
      defaultState
    } = this.props;

    if (
      value === null ||
      typeof value !== "object" ||
      (value === "object" && !value.hasOwnProperty("confirmation"))
    ) {
      const result = {
        aggreement: renderToStaticMarkup(children),
        context,
        confirmation: defaultState === true,
        timestamp: new Date()
      };

      setFieldValue(name, result, false);
    }
  }
  handleAggree(e) {
    //e.preventDefault();
    const { value, context, children, setFieldValue } = this.props;

    const result = {
      aggreement: renderToStaticMarkup(children),
      context,
      confirmation: !value.confirmation,
      timestamp: new Date()
    };
    setFieldValue(this.props.name, result);
  }
  render() {
    const { name, value, error } = this.props;
    if (value === null) return null;
    return (
      <FormLabel
        style={{
          marginLeft: "-14px",
          marginBottom: "0.8em",
          display: "inline-flex"

          //alignItems: "start"
        }}
      >
        <Checkbox
          name={name}
          onChange={this.handleAggree}
          checked={value.confirmation === true}
          style={{ marginTop: "-0.6em" }}
        />
        <Typography variant="body1" style={error ? { color: "red" } : null}>
          {this.props.children}
        </Typography>
      </FormLabel>
    );
  }
}
export default LegalCheckbox;
